import { ModalPlateBirthProps, typedMemo } from "src/types";
import { Modal } from "../modal/modal";
import { FormRow } from "../form-row/form-row";
import { InputText } from "../input-text/input-text";
import { Button } from "../button/button";
import { RightArrowIcon } from "src/assets";
import { useModalPlateBirth } from "./modal-plate-birth.hook";

export const ModalPlateBirth = typedMemo((props: ModalPlateBirthProps) => {
  const { formikInsertData, t, onCloseModal } = useModalPlateBirth(props);

  const { handleSubmit, handleChange, handleBlur, touched, errors, values } =
    formikInsertData;

  const Title = (
    <p className="text-center mb-4 mt-3 title-m--600 pre-line">
      {t("insert_plate_birth_page.title")}
    </p>
  );

  const Body = (
    <>
      <div className="mt-5">
        <FormRow
          full_row
          firstField={
            <InputText
              name={`plate`}
              handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                e.target.value = e.target.value.toUpperCase();
                handleChange(e);
              }}
              handleBlur={handleBlur}
              touched={touched.plate}
              value={values.plate}
              error={errors.plate}
              placeholder={t("insert_plate_birth_page.insert_plate")}
            />
          }
        />
      </div>
    </>
  );

  const Bottom = (
    <div className="d-flex flex-column jusfify-content-center mt-3">
      <div className="flex-lg-row flex-column d-flex mx-lg-auto">
        <Button
          flavor="transparentAccent"
          classes="px-lg-5 mx-lg-5 mb-lg-0 mx-0 px-2 mb-3 "
          text={t("commons.cancel")}
          classesText="text-uppercase label-l--500 c-dark-red"
          onPress={onCloseModal}
        />
        <Button
          flavor="primary"
          iconLeft={RightArrowIcon}
          classes="px-lg-5 mx-lg-5 mt-lg-0 mx-0 px-2 mt-3"
          text={t("commons.confirm")}
          classesText="text-uppercase label-l--500"
          onPress={handleSubmit}
        />
      </div>
    </div>
  );

  return (
    <Modal
      visible
      onClose={onCloseModal}
      classes="d-flex justify-content-center"
    >
      <div className="mb-4">
        {Title}
        <form>
          {Body}
          {Bottom}
        </form>
      </div>
    </Modal>
  );
});
